export default __webpack_public_path__ + "static/media/user(2).5b3b330b.svg";